module.exports = __webpack_public_path__ + "static/media/Icone-baixar-zip.b084d80a.svg";